import { TimelineMax } from 'gsap';

const ScrollDown = (element) => {
  const groupOne = element.querySelector('.scroll-down-group-1');
  const groupTwo = element.querySelector('.scroll-down-group-2');
  const groupThree = element.querySelector('.scroll-down-group-3');
  const groupFour = element.querySelector('.scroll-down-group-4');

  const tl = new TimelineMax({ paused: true, repeat: -1 });
  tl.addLabel('start')
    .to(groupOne, 0, {
      delay: 0.6,
      autoAlpha: 0,
    }, 'start')
    .to(groupTwo, 0, {
      delay: 1.2,
      autoAlpha: 0,
    }, 'start')
    .to(groupThree, 0, {
      delay: 1.8,
      autoAlpha: 0,
    }, 'start')
    .to(groupThree, 0, {
      delay: 2.4,
      autoAlpha: 1,
    }, 'start')
    .to(groupTwo, 0, {
      delay: 3,
      autoAlpha: 1,
    }, 'start')
    .to(groupThree, 0, {
      delay: 3.6,
      autoAlpha: 1,
    }, 'start');
  return tl;
};

export default ScrollDown;
